import React from "react"
import SearchBar from "../legacy_components/SearchBar"
import { parseQuery, toQuery } from "../models/FilterState"
import { getFilteredData } from "../util/getFilteredData"
import webify from "../util/webify"
import request from "../util/request"
import * as qs from "qs"
import FilterTabs from "./FilterTabs"

interface CustomListFiltersProps {
  searchPath: string
}

const CustomListFilters = (props: CustomListFiltersProps) => {
  return (
    <div className="filters-component items-end">
      <FilterTabs showCustom={true} />

      <div className="sm:col-span-2">
        <h3>Add Recipients</h3>

        <div
          className="search-bar passenger-filter__search-bar"
          data-role="passenger-filter-search"
        >
          <SearchBar
            renderSearchResultRow={renderSearchResultRow}
            debounceInput={false}
            performLookup={(query) => performLookup(props.searchPath, query)}
          />
        </div>
      </div>
      <div>
        <p className="text-sm text-gray-700 sm:max-w-para -mb-4 sm:mt-0">
          Add groups of passengers, account holders or emergency contacts to your announcement by
          searching for passengers' names or emails.
        </p>
      </div>
    </div>
  )
}

function performLookup(searchPath, query) {
  return request("POST", searchPath, { q: query })
}

function renderSearchResultRow(r, resetSearchState) {
  return (
    <div
      data-role={`search-result-${r.passenger_party_id}`}
      key={r.passenger_party_id}
      className="block hover:bg-gray-100 px-2 py-2"
      onClick={() => chooseItem(r, resetSearchState)}
    >
      <span className="font-medium text-gray-800">{r.person_full_name}</span>
      <div className="text-gray-600">{r.email}</div>
    </div>
  )
}

function chooseItem(r, resetSearchState) {
  let parsed = parseQuery(window.location.search)
  let ids = parsed.passengerPartyIdIn ?? []

  if (!ids.includes(r.passenger_party_id)) {
    ids.push(r.passenger_party_id)
  }

  getFilteredData(toQuery({ ...parsed, passengerPartyIdIn: ids }))

  resetSearchState()
}

export function idsToQuery(ids) {
  return qs.stringify(
    { custom: true, passenger_party_id_in: ids },
    { arrayFormat: "comma", encode: false }
  )
}

export default CustomListFilters
webify("custom-list-filters", CustomListFilters)
